module.exports = "/more-info5bea9bb3bea92f5ee8d12ffb533ac093.svg";